import assign from 'object-assign';
import compose from 'ramda/src/compose';
import defaultTo from 'ramda/src/defaultTo';
import replace from 'ramda/src/replace';
import prop from 'ramda/src/prop';
import pathOr from 'ramda/src/pathOr';

export const getPathFromContext = context => ( path, fallback ) => {
    return pathOr( fallback, path, context );
};

export function appendHashToUrl ( url, urlHash = '' ) {
    return urlHash ? `${url}#${urlHash}` : url;
}

export const pathFromConfigOr = getPathFromContext( upi.paths );
export const SITE_URL = pathFromConfigOr( ['SITE_URL'], '/' );
export const STORE_URL = pathFromConfigOr( ['STORE_URL'], '/checkout' );
export const LOGIN_URL = pathFromConfigOr( ['LOGIN_URL'], '/login' );
export const LOGIN_URL_WITH_REDIRECT = `${LOGIN_URL}?redirect=${encodeURIComponent( location.pathname +
    location.search )}`;
export const DISTRIBUTOR_URL = upi.paths.ALTERNATE_DISTRIBUTOR_URL ||
    `${SITE_URL}support/${encodeURIComponent( upi.conf.countryName )}`;
export const UPS_TRACKING_URL = 'http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=';
export const REDIRECT_404_URL = `${SITE_URL}error?type=404&source=${window.location.pathname}`;
export const REDIRECT_401_URL = `${LOGIN_URL}?redirect=${window.location.pathname}`;

// /Reviews/CreateReview/${BRAND_ID}
export const getCreateReviewURL = brandId =>
    `${pathFromConfigOr( ['WRITE_REVIEW_URL'], '/Reviews/CreateReview' )}/${brandId}`;

// /Reviews/EditReview/${UNIQUE_REVIEW_ID}
export const getEditReviewURL = uniqueReviewId =>
    `${pathFromConfigOr( ['EDIT_REVIEW_URL'], '/Reviews/EditReview' )}/${uniqueReviewId}`;

// takes a page path -> root of path excluding any "/"
export const getPathRoot = path => path.replace( /^\/?([^/]*).*$/, '$1' );

// takes site url, e.g. window.location.path -> pageRoot minus (siteURL + locale)
export const getPageRoot = compose( getPathRoot, replace( SITE_URL, '' ) );

// return the "url" prop of given object defaulting to "/"
export const getUrl = compose( defaultTo( '/' ), prop( 'url' ) );

// takes a pagePath and prepends the current (siteURL + locale) - removes leading slash on path if present
export const localizeURL = path => (SITE_URL + path.replace( /^\/+/, '' ));

export const mapRootUrl = node => child => {
    const nodeUrl = getUrl( node );
    const childUrl = getUrl( child );
    const prefix = nodeUrl.indexOf( '/' ) === 0 ? '' : SITE_URL;

    return assign( {}, child, {
        url: [prefix, nodeUrl, childUrl]
            .filter( Boolean )
            .join( '/' )
            .replace( /^\/\//, '/' )
    } );
};

export function toProductUrl ( {path, sku} ) {
    if ( sku ) {
        return `${path}?sku=${sku}`
    }

    return path;
}

export function decodeParam ( param = '' ) {
    if ( param == null ) {
        return '';
    }

    return decodeURIComponent( param.replace( /\+/g, ' ' ) );
}

export function getParameterByName ( name ) {
    name = name.replace( /[[]/, '\\[' ).replace( /[\]]/, '\\]' );
    const regexS = '[\\?&]' + name + '=([^&#]*)';
    const regex = new RegExp( regexS, 'g' );
    const results = regex.exec( window.location.href );

    if ( results == null ) {
        return '';
    }
    return decodeParam( results[1] );
}

export function getParameters ( search ) {
    var queryStr = search || window.location.search,
        queryArr = queryStr.replace( '?', '' ).split( '&' ),
        queryParams = [];

    for ( var q = 0, qArrLength = queryArr.length; q < qArrLength; q++ ) {
        var qArr = queryArr[q].split( '=' );

        if ( qArr[0].indexOf( '[]' ) !== -1 ) {
            if ( !queryParams[qArr[0]] ) {
                queryParams[qArr[0]] = [];
            }
            queryParams[qArr[0]] = queryParams[qArr[0]].concat( [decodeParam( qArr[1] )] );
            continue;
        }

        queryParams[qArr[0]] = decodeParam( qArr[1] );
    }

    return queryParams;
}

export function getSearchParams ( search ) {
    const searchParams = new URLSearchParams( search || window.location.search );

    const params = {};
    for ( const [key, value] of searchParams ) {
        params[key] = value;
    }

    return params;
}
